@if (computedStatistic(); as computedStatistic) {
    <div class="h-full w-full p-2">
        @switch (computedStatistic.render) {
            @case (RenderEnum.COLUMN) {
                <app-column-chart
                    [computedStatistic]="computedStatistic"
                    [isExpanded]="isExpanded()"
                    [isPrintScreen]="showLabels()"
                    (ready)="onReady()" />
            }
            @case (RenderEnum.LINE) {
                <app-line-chart
                    [computedStatistic]="computedStatistic"
                    [isExpanded]="isExpanded()"
                    [isPrintScreen]="showLabels()"
                    (ready)="onReady()" />
            }
            @case (RenderEnum.GAUGE) {
                <app-gauge-chart
                    [computedStatistic]="computedStatistic"
                    [isExpanded]="isExpanded()"
                    [isPrintScreen]="showLabels()"
                    (ready)="onReady()" />
            }
            @case (RenderEnum.PIE) {
                <app-pie-chart
                    [computedStatistic]="computedStatistic"
                    [isExpanded]="isExpanded()"
                    [isPrintScreen]="showLabels()"
                    (ready)="onReady()" />
            }
            @case (RenderEnum.VALUE) {
                <app-value-chart
                    [computedStatistic]="computedStatistic"
                    [isExpanded]="isExpanded()"
                    (ready)="onReady()" />
            }
        }
    </div>
}
